//Podiato default, add bnc later
export default [
  {
    path: '/',
    // component: (resolve) => import(`@/views/Main/Wrapper.vue`).then(resolve),
    component: (resolve) => import(`@/views/Auth/Wrapper.vue`).then(resolve),

    children: [
      {
        path: '/',
        name: 'LoginHome',
        meta: {
          guest: true
        },
        components: {
          router_wrapper_auth: (resolve) => import(`@/views/Auth/Login.vue`).then(resolve),
        }
      }
    ]
  },

  {
    path: '/errors',
    component: (resolve) => import(`@/views/Main/Wrapper.vue`).then(resolve),
    children: [
      {
        path: '401',
        name: 'Permission Denied',
        meta: {
          guest: true
        },
        components: {
          router_wrapper_main: (resolve) => import(`@/views/Errors/401.vue`).then(resolve),
        }
      },
      {
        path: '500',
        name: 'Server Error',
        meta: {
          guest: true
        },
        components: {
          router_wrapper_main: (resolve) => import(`@/views/Errors/500.vue`).then(resolve),
        }
      },
    ]
  },
  {
    path: '/c-panel',
    component: (resolve) => import(`@/views/CPanel/Wrapper.vue`).then(resolve),
    children: [
      {
        path: '/',
        name: 'MainCpan',
        meta: {
          requiresAuth: true
        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Staff/CustomersDashboard.vue`).then(resolve),
        }
      },
      {
        path: 'staff',
        name: 'Staff',
        meta: {
          requiresAuth: true
        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Staff/Staff.vue`).then(resolve),
        }
      },
      {
        path: 'customers/:staff_id',
        name: 'Customers',
        meta: {
          requiresAuth: true
        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Staff/Customers.vue`).then(resolve),
        }
      },
      {
        path: 'orders/:staff_id/:customer_id',
        name: 'Checkout',
        meta: {
          requiresAuth: true
        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Staff/Orders.vue`).then(resolve),
        }
      },
      {
        path: 'products/:staff_id/:customer_id',
        name: 'Products',
        meta: {
          requiresAuth: true
        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Staff/Products.vue`).then(resolve),
        }
      },
      {
        path: 'tabs/:staff_id/:customer_id',
        name: 'Tabs',
        meta: {
          requiresAuth: true
        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Staff/Tabs.vue`).then(resolve),
        }
      },
      /**
       * Admin Section
       */
      {
        path: 'admin/users',
        name: 'EditUsers',
        meta: {
          requiresAuth: true,
          authGroups: [1]
        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Admin/StaffList.vue`).then(resolve),
        }
      },
      {
        path: 'admin/staff',
        name: 'EditStaff',
        meta: {
          requiresAuth: true,
          authGroups: [1]

        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Admin/Staff.vue`).then(resolve),
        }
      },
      {
        path: 'admin/customers',
        name: 'EditCustomers',
        meta: {
          requiresAuth: true,
          authGroups: [1]

        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Admin/Customers.vue`).then(resolve),
        }
      },
      {
        path: 'admin/products',
        name: 'EditProducts',
        meta: {
          requiresAuth: true,
          authGroups: [1]

        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Admin/Products.vue`).then(resolve),
        }
      },
      {
        path: 'admin/categories',
        name: 'ProductCategories',
        meta: {
          requiresAuth: true,
          authGroups: [1]

        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Admin/Categories.vue`).then(resolve),
        }
      },
      {
        path: 'admin/promotions',
        name: 'Promotions',
        meta: {
          requiresAuth: true,
          authGroups: [1]

        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Admin/Promotions.vue`).then(resolve),
        }
      },
      {
        path: 'admin/orders',
        name: 'Orders',
        meta: {
          requiresAuth: true,
          authGroups: [1]

        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Admin/Orders.vue`).then(resolve),
        }
      },
      {
        path: 'admin/live-orders',
        name: 'LiveOrders',
        meta: {
          requiresAuth: true,
          authGroups: [1]

        },
        components: {
          router_wrapper_cpanel: (resolve) => import(`@/views/CPanel/Admin/LiveOrders.vue`).then(resolve),
        }
      },
    ]
  },
  {
    path: '/auth',
    component: (resolve) => import(`@/views/Auth/Wrapper.vue`).then(resolve),
    children: [
      {
        path: '',
        redirect: 'login'
      },
      {
        path: 'login',
        name: 'Login',
        meta: {
          guest: true
        },
        components: {
          router_wrapper_auth: (resolve) => import(`@/views/Auth/Login.vue`).then(resolve),
        }
      },
      {
        path: 'logout',
        name: 'Logout',
        meta: {
          guest: true,
          requiresAuth: true
        },
        components: {
          router_wrapper_auth: (resolve) => import(`@/views/Auth/Logout.vue`).then(resolve)
        }
      },
    ]
  },
];
